import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { InitiativeListItem } from "../types";

interface UseInitiativesListArgs {
  corporateId: string;
  page: number;
  pageSize: number;
  search?: string;
}

export const useInitiativesList = ({
  corporateId,
  page,
  pageSize,
  search,
}: UseInitiativesListArgs): PaginatedListResult<InitiativeListItem> => {
  const url = corporateId
    ? `${ServicesURL.initiative}/${corporateId}/initiatives?status=ACTIVE`
    : null;

  return usePaginatedList<InitiativeListItem>(url, {
    page,
    pageSize,
    search,
  });
};
